export const normalizeDealerOffers = offers => {
  if (Array.isArray(offers)) {
    return offers;
  }
  return Object.values(offers).filter(offer => offer !== undefined);
};
export const extractTitleFromDealerOffers = offers => {
  var _firstOffer$asset;
  const offersArray = normalizeDealerOffers(offers);
  if (offersArray.length === 0) {
    return undefined;
  }
  const firstOffer = offersArray[0];
  const creative = (_firstOffer$asset = firstOffer.asset) == null ? void 0 : _firstOffer$asset.creative;
  if (!creative) {
    return undefined;
  }
  return creative.business;
};
//# sourceMappingURL=dealer.utils.js.map